var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login" },
    [
      _c("Header"),
      _c("div", { staticClass: "ctn_box" }, [
        _c(
          "div",
          { staticClass: "form_ctn_center pa-5" },
          [
            _c("h1", { staticClass: "form_ctn_title" }, [
              _vm._v("Iniciar sesión"),
            ]),
            _c("div", { staticClass: "old__pass" }),
            _c("v-text-field", {
              attrs: {
                autofocus: "",
                type: "email",
                color: "#42a5f5",
                rules: _vm.emailRules,
                label: "Correo electrónico",
                outlined: "",
              },
              model: {
                value: _vm.email,
                callback: function ($$v) {
                  _vm.email = $$v
                },
                expression: "email",
              },
            }),
            _c("v-text-field", {
              attrs: {
                color: "#42a5f5",
                rules: _vm.rulesPass,
                label: "Contraseña",
                outlined: "",
                type: "password",
              },
              model: {
                value: _vm.password,
                callback: function ($$v) {
                  _vm.password = $$v
                },
                expression: "password",
              },
            }),
            _c(
              "div",
              { staticClass: "ctn_signin" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "btn_sign",
                    on: {
                      click: function ($event) {
                        return _vm.autenticate()
                      },
                    },
                  },
                  [_vm._v("INICIAR")]
                ),
                _c("p", { staticClass: "line" }),
              ],
              1
            ),
            _vm.errmensaje
              ? _c(
                  "v-alert",
                  {
                    staticClass: "alert-md",
                    attrs: { color: "red", text: "" },
                  },
                  [_vm._v(_vm._s(_vm.errmensaje))]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }